import { render, staticRenderFns } from "./AppLanding.vue?vue&type=template&id=12c243c0&scoped=true"
import script from "./AppLanding.vue?vue&type=script&lang=js"
export * from "./AppLanding.vue?vue&type=script&lang=js"
import style0 from "./AppLanding.vue?vue&type=style&index=0&id=12c243c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c243c0",
  null
  
)

export default component.exports